// Node Module Imports
import { colors } from './colors'

export const bs = {
  standard: '0 .1875rem .5rem rgba(0,0,0,.1)',
}
